import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-524bb2c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "exceptionPopup",
  class: "popup-vue"
}
const _hoisted_2 = { class: "popup-title sub-title" }
const _hoisted_3 = { class: "content mb30" }
const _hoisted_4 = { class: "popup-desc" }

import { onMounted, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionPopup',
  props: {
  context: {
    type: String,
    required: false,
  },
  popupTitle: {
    type: String,
    required: true,
  },
  popupDesc: {
    type: String,
    required: true,
  },
},
  emits: ['onClick_close'],
  setup(__props, { emit }) {

const props = __props;



/**** data -------------------- */
var className = ref('');
/**** methods ----------------- */
const setPopupImage = () => {
  let desc = props.popupDesc;
  if (desc.indexOf('완료') !== -1 || desc.indexOf('성공') !== -1) {
    return (className.value = 'img-check-main');
  } else if (desc.indexOf('선택해 주세요') !== -1) {
    return (className.value = 'img-check-point');
  } else if (desc.indexOf('실패') !== -1 || desc.indexOf('불가') !== -1 || desc.indexOf('확인해 주세요') !== -1) {
    return (className.value = 'img-x-point');
  } else if (desc.indexOf('입력해 주세요') !== -1) {
    return (className.value = 'img-search-point');
  } else if (desc.indexOf('첨부해 주세요') !== -1) {
    return (className.value = 'img-attatch-point');
  } else {
    return (className.value = 'img-check-point');
  }
};
/**** content -----------------
 *
 * 예외 팝업
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  setPopupImage();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.popupTitle), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", {
        class: _normalizeClass(["popup-img mb20", _unref(className)])
      }, null, 2),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.popupDesc), 1)
    ]),
    _createElementVNode("button", {
      class: "btn btn-type-1 btn-close",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_close')))
    }, "닫기")
  ]))
}
}

})